import * as React from "react"
import * as styles from "./styles.module.scss"

export interface JourneyItemProps {
  list: any
  heading: string
  imgAlt: string
  imgSrc: React.FC
}

const JourneyItem: React.FC<JourneyItemProps> = ({
  list,
  heading,
  imgAlt,
  imgSrc,
}) => {
  return (
    <div className={styles.item}>
      <div className={styles.journeyDetail}>
        <div className={styles.figureWrapper}>
          <figure className={styles.figure}>
            <img className={styles.image} src={imgSrc} alt={imgAlt} />
          </figure>
        </div>
        <div className={styles.copy}>
          <h4 className={styles.heading}>{heading}</h4>
          <ul className={styles.list}>
            {list.map((item, index) => (
              <li className={styles.journeyItem} key={index}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default JourneyItem
